import { AsyncPipe, JsonPipe, NgClass, UpperCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsService, TranslatePipe } from '@spartacus/core';
import { CmsComponentData, MediaComponent } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { RemoveImageTitleAttrDirective } from '../../../shared/remove-title-attr.directive';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgbCarouselModule,
    NgClass,
    MediaComponent,
    RemoveImageTitleAttrDirective,
    AsyncPipe,
    UpperCasePipe,
    JsonPipe,
    TranslatePipe,
  ],
})
export class BannerComponent implements OnInit {
  banner$: Observable<any> = this.componentData.data$;
  bannerData$: any;
  intervalTime: number;
  activeCountry$: Observable<string> = this.countryService.getActive();

  constructor(
    private componentData: CmsComponentData<any>,
    private cmsService: CmsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private countryService: ShimanoCountryService
  ) {}

  ngOnInit() {
    this.bannerData$ = this.banner$.pipe(
      switchMap((data) =>
        combineLatest(
          data.responsiveBanners
            .split(' ')
            .map((uid: string) => this.cmsService.getComponentData<any>(uid).pipe(map((d) => ({ ...d }))))
        )
      )
    );

    this.banner$.pipe(take(1)).subscribe((result) => {
      if (typeof result !== 'undefined') {
        if (result.timeout !== null) {
          this.intervalTime = result.timeout * 1000;
        } else {
          this.intervalTime = 5000;
        }
        this.cdr.detectChanges();
      }
    });
  }

  checkUrl(urlLink: any) {
    if (urlLink) {
      if (Object.keys(urlLink).length > 0) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  redirectTo(uri: any) {
    if (uri) {
      this.router.navigateByUrl(uri);
    }
  }
}
